import React, { useCallback, useMemo } from "react";
import { getTPRMAuditEventsApi } from "../../../services/axios/AuthApis/TPRMApis";
import TPRMResourceTable, { StatusBadge } from "./TPRMResourceTable";
import {
  displayTPRMValue,
  formatTPRMTimestamp,
} from "./tprmPageUtils";

const FILTERS = [
  {
    id: "resource_type",
    definition: {
      variant: "text",
      label: "Resource type",
      placeholder: "Filter by exact resource type",
    },
  },
  {
    id: "resource_id",
    definition: {
      variant: "text",
      label: "Resource reference",
      placeholder: "Filter by exact resource reference",
    },
  },
];

const AuditTrailPage = () => {
  const fetchPage = useCallback((params) => getTPRMAuditEventsApi(params), []);
  const columns = useMemo(
    () => [
      {
        accessorKey: "created_at",
        header: "Timestamp",
        size: 165,
        cell: ({ getValue }) => formatTPRMTimestamp(getValue()),
      },
      {
        accessorKey: "customer_name",
        header: "Customer",
        size: 180,
        cell: ({ row, getValue }) => (
          <div>
            {displayTPRMValue(getValue())}
            {row.original.customer_mapping_status !== "verified" && (
              <div className="text-xs text-amber-700">
                {row.original.customer_mapping_status || "unavailable"}
              </div>
            )}
          </div>
        ),
      },
      {
        accessorKey: "actor_id",
        header: "Actor",
        size: 180,
        cell: ({ getValue }) => displayTPRMValue(getValue()),
      },
      {
        accessorKey: "action",
        header: "Action",
        size: 200,
        cell: ({ getValue }) => displayTPRMValue(getValue()),
      },
      {
        accessorKey: "resource_type",
        header: "Resource type",
        size: 155,
        cell: ({ getValue }) => displayTPRMValue(getValue()),
      },
      {
        accessorKey: "resource_id",
        header: "Resource reference",
        size: 200,
        cell: ({ getValue }) => displayTPRMValue(getValue()),
      },
      {
        accessorKey: "outcome",
        header: "Outcome",
        size: 135,
        cell: ({ getValue }) => <StatusBadge value={getValue()} />,
      },
    ],
    [],
  );

  return (
    <TPRMResourceTable
      columns={columns}
      description="Read-only history within the authenticated user's authorized TPRM scope."
      fetchPage={fetchPage}
      filters={FILTERS}
      getRowId={(event) => event.id}
      title="Audit Trail"
    />
  );
};

export default AuditTrailPage;
